export type CommentPanelSort = "priority" | "newest" | "newest_replies" | "oldest";

export const DEFAULT_COMMENT_PANEL_SORT: CommentPanelSort = "priority";

export function isCommentPanelSortActive(sort: CommentPanelSort): boolean {
  return sort !== DEFAULT_COMMENT_PANEL_SORT;
}
